<template>
  <div :key="refreshKey" class="w-full relative flex flex-col">
    <div class="alert flex flex-col gap-5">
      <div v-if="hasActiveAlerts" class="flex flex-col gap-2">
        <StartUpAlertView v-if="isMainAlert" @close="closeMainAlert" />
        <StartUpAlertSubscription v-if="isSubAlert" @close="closeSubAlert" />
      </div>
      <div>
        <h3
          class="font-semibold text-xl leading-8 text-main-800 dark:text-gray-200"
        >
          Hi, {{ fullName }}
        </h3>
      </div>
      <div
        class="dashboard w-full grid grid-cols-1 xl:grid-cols-[1fr_20rem] gap-2"
      >
        <!-- Left section -->
        <div class="left_section flex flex-col gap-2">
          <StartupWelcomeMessage v-if="testDisplay" />
          <StepForm v-if="testDisplay" />
          <DailyBusinessOverview />
          <RecentOrdersDashboardView />
        </div>

        <!-- Right section (aside) -->
        <div class="aside flex flex-col gap-2 landscape:max-w-[20rem]">
          <QuickAction />
          <VideoGuideAid />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StartUpAlertView from "./startUpAlertView.vue";
import StartUpAlertSubscription from "./startUpAlertSubscription.vue";
import StartupWelcomeMessage from "./welcomeMessage.vue";
import StepForm from "./startUpSteps.vue";
import DailyBusinessOverview from "./dailyBusinessOverview.vue";
import RecentOrdersDashboardView from "./recentOrders.vue";
import QuickAction from "./quickAction.vue";
import VideoGuideAid from "./videoAid.vue";

export default {
  name: "DashboardView",
  data() {
    return {
      testDisplay: false,
      fullName: this.$store.state.userName.split(" ")[0] || "",
      isSubAlert: true,
      refreshKey: this.$store.state.storeUpdatedAt || Date.now(),
    };
  },
  components: {
    StartUpAlertView,
    StartUpAlertSubscription,
    StartupWelcomeMessage,
    StepForm,
    DailyBusinessOverview,
    RecentOrdersDashboardView,
    QuickAction,
    VideoGuideAid,
  },
  watch: {
    "$store.state.storeUpdatedAt": {
      immediate: true,
      handler(val) {
        this.refreshKey = val;
      },
    },
  },
  computed: {
    hasActiveAlerts() {
      return this.isMainAlert || this.isSubAlert;
    },
    isMainAlert() {
      return this.$store.state.isEmailVerified;
    },
  },
  methods: {
    closeMainAlert() {
      console.log("Closing Main Alert");
      this.isMainAlert = false;
    },
    closeSubAlert() {
      console.log("Closing Sub Alert");
      this.isSubAlert = false;
    },
  },
};
</script>
